import { API } from 'src/definitions';
import Schema from 'validate';

export default new Schema<API.Steps.UpdateStep.Request>(
  {
    name: {
      required: false,
      type: 'string',
      message: {
        required: 'A name is required'
      }
    },
    position: {
      required: false,
      type: 'number',
      message: {
        required: 'A position is required'
      }
    }
  },
  { strip: false }
);
